<template>
  <v-card class="d-flex flex-column addLogWorkType">
    <div class="addLogWorkType__container">
      <div class="addLogWorkType__container--title">
        <p class="text">Add Work Type</p>
      </div>
      <div class="d-flex flex-column addLogWorkType__reference">
        <v-autocomplete
          outlined
          label="Work type reference"
          item-text="workTypeName"
          return-object
          :items="getWorkTypeRefs(workType.orderPosition)"
          v-model="workType.customerPriceList"
        ></v-autocomplete>
        <v-text-field
          outlined
          label="Quantity"
          type="number"
          v-model="workType.quantity"
        ></v-text-field>
      </div>
      <div class="d-flex align-center justify-end addLogWorkType__actions">
        <v-btn
          text
          @click="setLogWorkTypeModalOpen(false)"
        >
          Cancel
        </v-btn>
        <v-btn
          color="#006BD6"
          class="white--text"
          @click="updateWorkTypeRefs"
        >
          Add
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ADLogWorkType",

  data() {
    return {
      workType: {
        orderPosition: 1,
        customerPriceList: null,
        quantity: null
      }
    }
  },

  computed: {
    ...mapGetters("assignment", [
      "assignmentForm",
      "workTypeReferences",
      "iTunesWorkType1References",
      "editingWorkType"
    ]),
    isCue() {
      return (
        this.assignmentForm.relatedProject?.name !== "iTunes FC" &&
        this.assignmentForm.relatedProject?.name !== "iTunes Music"
      );
    },
  },

  methods: {
    ...mapActions("assignment", ["setLogWorkTypeModalOpen", "addWorkTypeReference", "setEditingWorkType", "updateWorkType"]),
    getWorkTypeRefs(index) {
      console.log('this.workTypeReferences', this.workTypeReferences);
      return this.isCue || index > 6
        ? this.workTypeReferences
        : this.workTypeReferences.filter((el) =>
            this[`iTunesWorkType${index}References`].includes(el.workTypeName)
          ).concat(this.assignmentForm.requestType === "Localization" ? [this.workTypeReferences.find(el => el.workTypeName === "LOC_300-100-700")] : [""]);
    },
    updateWorkTypeRefs() {
      this.updateWorkType({
        index: this.editingWorkType ? this.editingWorkType.index : null,
        workType: this.workType
      });

      // reset local form
      this.workType = {
        orderPosition: 1,
        customerPriceList: null,
        quantity: null
      };
      this.setEditingWorkType(null);
      this.setLogWorkTypeModalOpen(false);
    }
  },

  watch: {
    editingWorkType: {
      immediate: true,
      handler(val) {
        console.log('val', val);
        if (val) {
          this.workType = JSON.parse(JSON.stringify(val));
        } else {
          this.workType = {
            orderPosition:
              this.assignmentForm.pricing.workTypes.length + 1,
            customerPriceList: null,
            quantity: null
          };
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.addLogWorkType {
  padding: 15px;
  background-color: #fff;
  &__container {
    padding: 20px;
    border-radius: 4px;
    background-color: #fff;
    &--title {
      margin-bottom: 30px;
      & .text {
        font-family: 'Roboto', sans-serif;
        font-size: 20px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
        color: #000000;
      }
    }
  }
  &__actions {
    gap: 8px;
  }
}
</style>